/**
 * Что здесь не так:
 * Если таких слайдеров будет на странице несколько, то события будут пересекаться
 * todo: fix
 */

export {};

const arrow = 'arrow-v3';
const $window = $(window);
const SLIDER_SELECTOR = '.js-history-slider';
const SLIDER_FOR = '.history';
const isIe11 = Modernizr.ie11;
const arrowPrev = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--prev"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-left"><use xlink:href="#svg-symbol--${arrow}-left"/></svg></button>`;
const arrowNext = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--next"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-right"><use xlink:href="#svg-symbol--${arrow}-right"/></svg></button>`;
let $btnStart = null;
let $btnEnd = null;

NLMK.historySliderInit = historySliderInit;

window.addEventListener('load', function() {
    $(historySliderInit);
});


function historySliderInit() {
    const toggleArrows = function($slider, $sliderHistory) {
        const $arrowNext = $slider.siblings('.strategy-slider__nav').find('.strategy-slider__arrow--next');
        const $arrowPrev = $slider.siblings('.strategy-slider__nav').find('.strategy-slider__arrow--prev');

        const $lastSlide = $sliderHistory.find('.slick-slide').last();
        const $firstSlide = $sliderHistory.find('.slick-slide').first();

        $firstSlide.hasClass('slick-current')
            ? $arrowPrev.addClass('true-slick-disabled')
            : $arrowPrev.removeClass('true-slick-disabled');

        $lastSlide.hasClass('slick-current')
            ? $arrowNext.addClass('true-slick-disabled')
            : $arrowNext.removeClass('true-slick-disabled');
    };

    $(SLIDER_SELECTOR).each(function(sliderIndex, SliderElement) {
        let isAllSlideVisible = false;
        const $slider = $(SliderElement);
        const $slides = $slider.find('.strategy-slider__slide');
        const activeSlideIdx = $slider.data('active-slide');
        let easing = 'ease';

        if (isIe11) {
            easing = 'none';
        }

        if (($slides.length <= 8 && innerWidth >= 1660) || ($slides.length <= 6 && innerWidth >= 1400)) {
            isAllSlideVisible = true;
        }

        const $sliderHistory = $(SLIDER_FOR);

        $slider
            .on('init', function() {
                if (activeSlideIdx) {
                    setTimeout(() => {
                        $slider.css('visibility', 'visible');
                        $slider.find(`[data-slick-index=${activeSlideIdx}]`).addClass('is-active');
                        toggleArrows($slider, $sliderHistory);
                    }, 100);
                } else {
                    $slider.css('visibility', 'visible');
                }

                const $nav = $slider.siblings('.strategy-slider__nav');

                $nav.append(arrowPrev);
                $nav.append(arrowNext);

                const $arrowNext = $nav.find('.strategy-slider__arrow--next');
                const $arrowPrev = $nav.find('.strategy-slider__arrow--prev');

                $arrowNext.on('click', () => {
                    if ($arrowNext.hasClass('js-switching')) {
                        return;
                    }

                    $arrowNext.addClass('js-switching')
                    $slider.slick('slickNext');
                    $sliderHistory.slick('slickNext');

                    setTimeout(() => {
                        $arrowNext.removeClass('js-switching');
                    }, 300);
                });
                $arrowPrev.on('click', () => {
                    if ($arrowNext.hasClass('js-switching')) {
                        return;
                    }

                    $arrowNext.addClass('js-switching')
                    $slider.slick('slickPrev');
                    $sliderHistory.slick('slickPrev');

                    setTimeout(() => {
                        $arrowNext.removeClass('js-switching');
                    }, 300);
                });

                $sliderHistory.on('beforeChange', function(e, slick, prev, next) {
                    $slider.find('.slick-slide').removeClass('is-active');
                    $slider.find(`[data-slick-index=${next}]`).addClass('is-active');
                });
            })
            .slick({
                dots: false,
                arrows: false,
                infinite: false,
                initialSlide: +activeSlideIdx || 0,
                slidesToShow: 8,
                swipeToSlide: true,
                prevArrow: arrowPrev,
                nextArrow: arrowNext,
                appendArrows: '.strategy-slider__nav',
                focusOnSelect: true,
                asNavFor: SLIDER_FOR,
                cssEase: easing,
                responsive: [
                    {
                        breakpoint: 1660,
                        settings: {
                            slidesToShow: 8,
                        },
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 6,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })
            .on('afterChange', function(e, slick) {
                const { $slider, currentSlide } = slick;
                if (!isAllSlideVisible) {
                    toggleArrows($slider, $sliderHistory);
                }
                toggleBtnNav($slider);
                $slider.find('.is-show').removeClass('is-show');
                $slider
                    .find('.slick-slide')
                    .eq(currentSlide)
                    .find('.strategy-slider__slide')
                    .addClass('is-show');
            })
            .on('click', '.slick-slide', function(e) {
                const $slide = $(e.currentTarget);
                const index = $slide.data('slick-index');
                // goto history slider
                $sliderHistory.slick('slickGoTo', index);
            })
            .on('breakpoint', function(e, slick) {
                generateBtnStartEnd($slider, $sliderHistory);
                const activeContent = slick.$slider.find('.is-show');

                if (activeContent.length) {
                    const activeSlide = activeContent.closest('.slick-slide');
                    const slideIdx = activeSlide.data('slick-index');

                    setTimeout(() => {
                        slick.$slider.slick('slickGoTo', +slideIdx);
                        activeSlide.addClass('is-active');
                    }, 100);
                }
            });

        $sliderHistory
            .slick({
                initialSlide: +activeSlideIdx || 0,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                asNavFor: SLIDER_SELECTOR,
                infinite: false,
                draggable: false,
                cssEase: easing,
                adaptiveHeight: true,
                focusOnSelect: false,
                focusOnChange: false,
                accessibility: false,
            })
            .on('afterChange', function() {
                $sliderHistory.slick('setPosition');
                toggleArrows($slider, $sliderHistory);
            })
            .on('setPosition', function() {
                $window.trigger('slickSetPosition', 'history');
            });

        generateBtnStartEnd($slider, $sliderHistory);
    });
}

function generateBtnStartEnd($slider, $sliderHistory) {
    const isMobile = window.innerWidth < 768;
    const startText = $slider.data('start');
    const endText = $slider.data('end');

    $slider.prepend(`<div class="btn-history-wrap btn-history-wrap-left"><button class="btn-history-nav js-btn-history-start">${startText}</button</div>`);
    $slider.append(`<div class="btn-history-wrap btn-history-wrap-right"><button class="btn-history-nav js-btn-history-end">${endText}</button</div>`);
    $btnStart = $('.js-btn-history-start');
    $btnEnd = $('.js-btn-history-end');
    const $nav = $slider.siblings('.strategy-slider__nav');
    const $btnNext = $nav.find('.strategy-slider__arrow--next');
    const $btnPrev = $nav.find('.strategy-slider__arrow--prev');
    $btnNext.css('right', isMobile ? 0 : $btnEnd.outerWidth());
    $btnPrev.css('left', isMobile ? 0 : $btnStart.outerWidth());

    $btnStart.click(() => {
        $slider.slick('slickGoTo', 0);
        $sliderHistory.slick('slickGoTo', 0);
    });

    $btnEnd.click(() => {
        $slider.slick('slickGoTo', $slider[0].slick.slideCount);
        $sliderHistory.slick('slickGoTo', $slider[0].slick.slideCount);
    });
}

function toggleBtnNav($slider) {
    const $lastSlide = $slider.find('.slick-slide').last();
    const $firstSlide = $slider.find('.slick-slide').first();

    const isFirstSlideVisible = $firstSlide.hasClass('slick-active');
    const isLastSlideVisible = $lastSlide.hasClass('slick-active');

    if (isLastSlideVisible) {
        $btnEnd.addClass('in-active');
    } else {
        $btnEnd.removeClass('in-active');
    }

    if (isFirstSlideVisible) {
        $btnStart.addClass('in-active');
    } else {
        $btnStart.removeClass('in-active');
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/history.js